module.exports = require("source-map-loader");